import { ref, computed } from 'vue'

const TOKEN_KEY = 'dpweb_token'
const USER_KEY = 'dpweb_user'

export interface StoredUser {
  id: number
  email: string
  type: 'syx' | 'userx'
  role?: number       // syx only
  user_level?: number // userx only
}

const token = ref<string | null>(localStorage.getItem(TOKEN_KEY))
const user = ref<StoredUser | null>(null)

// Restore user from localStorage on init
const stored = localStorage.getItem(USER_KEY)
if (stored) {
  try {
    const legacyUser = JSON.parse(stored) as StoredUser
    user.value = {
      id: legacyUser.id,
      email: legacyUser.email,
      type: legacyUser.type,
      ...(legacyUser.role !== undefined ? { role: legacyUser.role } : {}),
      ...(legacyUser.user_level !== undefined ? { user_level: legacyUser.user_level } : {}),
    }
    localStorage.setItem(USER_KEY, JSON.stringify(user.value))
  } catch {
    localStorage.removeItem(USER_KEY)
  }
}
export function useAuth() {
  const isLoggedIn = computed(() => !!token.value)
  const isSyx = computed(() => user.value?.type === 'syx')
  const isUserx = computed(() => user.value?.type === 'userx')
  const isAdmin = computed(() => isSyx.value && [0, 2, 3, 10].includes(user.value?.role ?? -1))

  function setSession(t: string, u: StoredUser) {
    token.value = t
    user.value = u
    localStorage.setItem(TOKEN_KEY, t)
    localStorage.setItem(USER_KEY, JSON.stringify(u))
  }

  function updateUser(u: StoredUser) {
    user.value = u
    localStorage.setItem(USER_KEY, JSON.stringify(u))
  }

  function clearSession() {
    token.value = null
    user.value = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
  }

  function getToken(): string | undefined {
    return token.value ?? undefined
  }

  return {
    token,
    user,
    isLoggedIn,
    isSyx,
    isUserx,
    isAdmin,
    setSession,
    updateUser,
    clearSession,
    getToken,
  }
}
